const baseUrl = "https://nbldocs.nablasol.net"; //PROD
// const baseUrl = "https://admindms.consumerlaw.com/public"; //DEV
export const sugarCasesUrl = "https://uat.consumerlaw.com/#Cases";

export default baseUrl;
